import {
  TransactionSupportInstructsParams,
  TransactionSupportInstructsTypes,
  OpenTradingAccountDetailDataTypes,
  InstructCategoryParamsTypes,
  InstructCategoryDataTypes,
  TransactionSupportInstructsExportType,
} from './types';

import axiosInstance from 'services/common/instance';

// Get HTGD Instruct Category list
export const getInstructCategoriesService = async (
  params?: InstructCategoryParamsTypes,
): Promise<InstructCategoryDataTypes[]> => {
  const res = await axiosInstance.get('htgd-instruct-categories', { params });
  return res.data.data;
};

// Get HTGD Instruct List
const getTransactionSupportInstructsService = async (
  params?: TransactionSupportInstructsParams,
): Promise<PaginationData<TransactionSupportInstructsTypes[]>> => {
  const res = await axiosInstance.get('htgd-instructs', { params });
  return res.data;
};

export const getOpenTradingAccountService = async (
  slug: string,
): Promise<OpenTradingAccountDetailDataTypes> => {
  const response = await axiosInstance.get(`htgd-instructs/${slug}`);
  return response.data.data;
};

export const getExportTransactionInstructsService = async (
  id: string,
  grecaptchaToken: string,
): Promise<TransactionSupportInstructsExportType> => {
  const formData = new FormData();
  formData.append('grecaptcha_token', grecaptchaToken);
  formData.append('id', id);
  const response = await axiosInstance.post('htgd-instructs/export', formData);
  return response.data.data;
};

export default getTransactionSupportInstructsService;
